import React from 'react';
import PropTypes from 'prop-types';

import { FormattedMessage } from 'react-intl';
// Import Shared Components
import { Button } from 'shared-components';

const ButtonWrapper = ({ buttonText, buttonFor, page, ...props }) => (
  <Button
    {...props}
  >
    <FormattedMessage
      id={`${page}-${buttonFor}-button`}
      description={`Button for ${buttonFor}`}
      defaultMessage={buttonText}
      {...props}
    />
  </Button>
);

ButtonWrapper.propTypes = {
  buttonText: PropTypes.string.isRequired,
  buttonFor: PropTypes.string.isRequired,
  page: PropTypes.string.isRequired
};

export default ButtonWrapper;
